import { hasYesOrNo } from 'models/validate';
import { ValidateJSModel } from 'forms/shared/types';
import { LegalAssociationsTerrorismAssociationModel } from './types';

const legalAssociationsTerrorismAssociationValidator: ValidateJSModel<LegalAssociationsTerrorismAssociationModel> = {
  HasTerrorism: { presence: true, hasValue: { validator: hasYesOrNo } },

  Explanation: (value, attributes) => {
    if (attributes?.HasTerrorism?.value === 'Yes') {
      return {
        presence: true,
        hasValue: true,
      };
    }

    return {};
  },
};

export default legalAssociationsTerrorismAssociationValidator;
